<template>
    <el-dialog :title="roleId ? '编辑授权' : '新增授权'" :visible.sync="authorizedOperatorVisible" width="600px" :before-close="handleDialogClose" :close-on-click-modal="false"
        class="custom-form-dialog custom-authorized-dialog" >
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top" v-loading="loading">
            <el-form-item label="授权人员" prop="relations">
                <template slot="label">
                    <p style="display: inline-block;">授权人员<span class="label-tip-txt">（被授权的人员拥有下方配置的全部权限）</span></p>
                </template>
                <div  >
                    <el-select :popper-append-to-body="false"
                               @focus="handleClickSelectAuthor(formData.relations)"
                               @remove-tag="handleClickRemoveAuthor(formData.relations)"
                               clearable collapse-tags key="selectPromoter"
                               multiple placeholder="点击授权"
                               popper-class="selectPopperHideClass"
                               ref="selectPromoter"
                               v-model.trim="formData.relations.ids">
                        <el-option v-for="item in formData.relations.value" :value="item.relate_type_id" :label="item.relate_name" ></el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="权限范围" prop="uid" class="label-bold custom-form-item-content">
                <ul class="author-list">
                    <li class="author-list-item" v-for="item in authorList">
                        <div class="author-list-header flex">
                            <div>
                                <p class="text-bold" v-text="item.name"></p>
                                <p v-text="item.module_desc"></p>
                            </div>
                            <el-switch  v-model="item.switch"></el-switch>
                        </div>
                        <div class="author-list-content" v-if="item.switch && (item.data_permission == 1 || item.children.length)">
                            <div class="content-tag-item" v-if="item.data_permission == 1">
                                <p class="text-bold">可见数据范围
                                    <el-tooltip class="item" content="设置可查看及可操作的数据范围" effect="dark" placement="top-start">
                                        <span class="handle_icon_wrap">
                                            <i class="iconfont icon-bangzhuzhongxin"></i>
                                        </span>
                                    </el-tooltip>
                                </p>
                                <!--如果是仓库模块-->
                                <template v-if="item.name_en == 'WarehouseManagement'">
                                    <el-checkbox class="mt_16" v-model="item.is_stock_all" :disabled="(item.stock && item.stock.length == 0) ? false : true" label="全部仓库" ></el-checkbox>
                                    <p class="text-bold mt_12">自定义仓库可见范围</p>
                                    <el-select :disabled="item.is_stock_all" style="margin-top: 4px" v-model="item.stock" size="small" multiple filterable placeholder="请选择仓库可见范围" @change="handleChangeStock($event,item)">
                                        <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in stockList"> </el-option>
                                    </el-select>
                                </template>

                                <!--别的模块-->
                                <template v-else>
                                    <el-checkbox-group v-model="item.data_permission_value">
                                        <el-checkbox v-for="item in dataPermissionList" :label="item.value" :disabled="item.disabled">{{item.label}}</el-checkbox>
                                    </el-checkbox-group>
                                    <div  v-if="item.data_permission_value.indexOf('custom') > -1">
                                        <el-select :popper-append-to-body="false"
                                                   @focus="handleClickSelectAuthor(item.relations)"
                                                   @remove-tag="handleClickRemoveAuthor(item.relations)"
                                                   clearable collapse-tags key="selectPromoter"
                                                   multiple placeholder="点击授权"
                                                   popper-class="selectPopperHideClass"
                                                   ref="selectPromoter"
                                                   v-model.trim="item.relations.ids">
                                            <el-option v-for="item in item.relations.value" :value="item.relate_type_id" :label="item.relate_name" ></el-option>
                                        </el-select>
                                    </div>
                                </template>


                            </div>
                            <div class="content-tag-item" v-if="item.children.filter(find => find.data_type == 0).length > 0">
                                <p class="text-bold">常规权限</p>
                                <div class="flex" v-for="list in item.children.filter(find => find.data_type == 0)">
                                    <div class="check-box">
                                        <el-checkbox :disabled="list.status == 1" v-model="list.switch"></el-checkbox>
                                    </div>
                                    <div>
                                        <p v-text="list.name"></p>
                                        <p  v-text="list.module_desc"></p>
                                    </div>
                                </div>

                            </div>
                            <div class="content-tag-item" v-if="item.children.filter(find => find.data_type == 1).length > 0">
                                <p class="text-bold">敏感权限</p>
                                <div class="flex" v-for="list in item.children.filter(find => find.data_type == 1)">
                                    <div class="check-box">
                                        <el-checkbox  :disabled="list.status == 1" v-model="list.switch"></el-checkbox>
                                    </div>
                                    <div>
                                        <p v-text="list.name"></p>
                                        <p  v-text="list.module_desc"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                </ul>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm">确认</el-button>
        </span>

        <userDepartmentPostSelection :userDepartmentPostVisible.sync="userDepartmentPostVisible" v-if="userDepartmentPostVisible" :userDepartmentPostSelected="userDepartmentPostSelected" :selectType="'departmentUserTag'" :userDepartmentPostTitle="'授权人员'"  @success="userDepartmentPostSuccess"/>

    </el-dialog>
</template>
<script>
import { modulePermissions,addUserPermissions,getVirtualRoleDetail,updateUserPermissions,stockListNotAuth} from "@/api/index.js"
import userDepartmentPostSelection from "@/components/pComponents/userDepartmentPostSelection.vue";
import {mapState} from "vuex";

export default {
    name: "authorizedOperatorVisible",
    components: {
        userDepartmentPostSelection
    },
    props: {
        authorizedOperatorVisible: {
            type: Boolean,
            default: false
        },
        roleId: {
            type: Number,
            default: 0
        },
        moduleName: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            loading:false,
            BtnDisabled:false,
            formData: {
                relations: {
                   ids:[],
                   value:[]
                }
            },
            formRules: {
                relations: [ {
                    required: true,
                    trigger: "change",
                    validator: (rule, value, callback) => {
                        if (value.ids.length == 0) return callback(new Error("请选择授权人员"));
                        callback();
                    }, } ]
            },
            userList: [],
            authorizedPersonnelData:{},
            authorList:[],
            dataPermissionList:[
                {value:'all',label:'全部数据'},
                {value:'self',label:'本人',disabled:true},
                {value:'self_department',label:'本部门及下级'},
                {value:'custom',label:'自定义范围'},
            ],
            userDepartmentPostVisible:false,
            userDepartmentPostSelected:[],
            activeRelations:null,
            stockList:[],

        }
    },
    created() {
        if(this.moduleName && this.moduleName == 'stock'){
            this.getStockList()
        }
       this.getModulePermissions()
    },
    methods: {
        // 编辑时获取详情
        getVirtualRoleDetail(){
            let postData = {
                role_id:this.roleId
            }
            getVirtualRoleDetail(postData).then(res=> {
                if(res.code === 200) {
                    let {relations,data_permissions,permission_names} = res.data
                    // 授权人员赋值
                    this.formData.relations = {
                        ids:relations.map((item)=>{
                            return   item.relation_id + '_' +item.relation_type
                        }),
                        value:relations.map((item)=>{
                            return {
                                relate_id: item.relation_id,
                                relate_name: item.relation_name,
                                relate_type: item.relation_type,
                                relate_type_id: item.relation_id + '_' +item.relation_type,
                            }
                        })
                    }
                    // 编辑时赋值

                    this.authorList.forEach((item)=>{
                        // 可见数据范围赋值
                        let info = data_permissions.find(find => find.module_id == item.id)
                        // info && info.permission_type &&  info.permission_type == 'user'
                        if(info && info.permission_type &&  item.name_en != 'WarehouseManagement'){
                            let data_permission_value = []
                            if(info.range.all){data_permission_value.push('all')}
                            if(info.range.self){data_permission_value.push('self')}
                            if(info.range.self_department){data_permission_value.push('self_department')}
                            if(info.range.custom.length>0){data_permission_value.push('custom')}
                            this.$set(item,'data_permission_value',data_permission_value)
                            this.$set(item,'relations',{value:info.range.custom,ids:info.range.custom.map((item)=>{return  item.relate_type_id}) })
                        }else if(info && info.permission_type &&  item.name_en == 'WarehouseManagement'){
                            // info && info.permission_type &&  info.permission_type == 'stock'
                            if(info.range.stock && info.range.stock == 'all'){
                                this.$set(item,'stock',[])
                                this.$set(item,'is_stock_all',true)
                            }else{
                                this.$set(item,'stock',info.range.stock ? info.range.stock : [])
                            }
                        }
                        // 选中节点
                        console.log(permission_names);
                        if(permission_names.findIndex(find => find.module_id == item.id) > -1){
                            this.$set(item,'switch',true)
                            if(item.children){
                                item.children.forEach((list)=>{
                                    if(permission_names.findIndex(find => find.module_id == list.id) > -1){
                                        this.$set(list,'switch',true)
                                    }
                                })
                            }
                        }
                    })
                }
                this.loading = false
            })
        },
        // 获取模块权限范围
        getModulePermissions(){
            let postData = {
                module_name: this.moduleName
            }
            this.loading = true
            modulePermissions(postData).then(res=> {
                if(res.code === 200) {
                    let data =  res.data[0].children
                    let flag = false
                    data.forEach((item)=>{
                        this.$set(item,'switch',false)
                        if(item.name_en == 'WarehouseManagement'){
                            this.$set(item,'stock',[])
                            this.$set(item,'is_stock_all',false)
                        }else{
                            this.$set(item,'data_permission_value',['self'])
                        }
                        this.$set(item,'relations',{value:[],ids:[]})
                        // if(item.status){
                        //     this.$set(item,'switch',true)
                        // }
                        if(item.children){
                            item.children.forEach((list)=>{
                                this.$set(list,'switch',false)
                                if(list.status){
                                    this.$set(list,'switch',true)
                                }
                            })
                        }
                    })
                    this.authorList = data

                    if(this.roleId){
                        this.getVirtualRoleDetail()
                    }else{
                        this.loading = false
                    }

                }else{
                    this.loading = false
                }

            })
        },
        // 获取仓库
        getStockList(){
            stockListNotAuth({}).then(res => {
                if (res.code === 200) {
                    this.stockList = res.data
                }
            })
        },
        // 选择人员
        handleClickSelectAuthor(field) {
            this.userDepartmentPostSelected = JSON.parse(JSON.stringify(field.value))
            this.activeRelations = field
            this.userDepartmentPostVisible = true
        },
        // 删除人员
        handleClickRemoveAuthor(field){
            field.value.splice(0,1)
        },
        // 选择完毕后回调
        userDepartmentPostSuccess(data){
            this.activeRelations.value = data
            this.activeRelations.ids = data.map((item)=>{
                return item.relate_type_id
            })
        },
        // 选择可见数据范围
        handleChangePermission(event,item){
            if(event.indexOf('custom') < 0){
                this.$set(item,'relations',{value:[],ids:[]})
            }
        },
        // 选择仓库可见范围
        handleChangeStock(event,item){

        },
        handleDialogClose() {
            this.$emit("update:authorizedOperatorVisible", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {

                    let permission_ids = []
                    let data_permissions = []
                    this.authorList.forEach((item)=>{
                        if(item.switch){
                            permission_ids.push(item.id)
                            if(item.data_permission == 1){
                                if(item.name_en == 'WarehouseManagement'){
                                    data_permissions.push({
                                        level_2_permission_id:item.id,
                                        data:{
                                            stock:item.is_stock_all ? 'all' : item.stock
                                        }
                                    })
                                }else{
                                    data_permissions.push({
                                        level_2_permission_id:item.id,
                                        data:{
                                            all: item.data_permission_value.indexOf('all') > -1 ?  true : false,
                                            self: item.data_permission_value.indexOf('self') > -1 ?  true : false,
                                            self_department: item.data_permission_value.indexOf('self_department') > -1 ?  true : false,
                                            custom:item.relations ? item.relations.value : []
                                        }
                                    })
                                }

                            }
                            if(item.children){
                                item.children.forEach((child)=>{
                                    if(child.switch){
                                        permission_ids.push(child.id)
                                    }
                                })
                            }

                        }
                    })
                    let postData = {
                        module_name:this.moduleName,
                        relations:this.formData.relations.value,
                        permission_ids:permission_ids,
                        data_permissions:data_permissions, //数据权限
                    }
                    this.BtnDisabled = true
                    if(this.roleId){
                        postData.role_id = this.roleId
                        postData.update_type = 'all'  // all【详情页使用，更新全部信息】
                        updateUserPermissions(postData).then(res=> {
                            if(res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '编辑成功',
                                    duration: 1500,
                                    onClose: () => {
                                        this.$emit('success')
                                        this.handleDialogClose()
                                        this.BtnDisabled = false
                                    }
                                })
                            }else{
                                this.BtnDisabled = false
                            }
                        })
                    }else{
                        addUserPermissions(postData).then(res=> {
                            if(res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '添加成功',
                                    duration: 1500,
                                    onClose: () => {
                                        this.$emit('success')
                                        this.handleDialogClose()
                                        this.BtnDisabled = false
                                    }
                                })
                            }else{
                                this.BtnDisabled = false
                            }
                        })
                    }



                }
            })



        },

    }
}
</script>
<style lang="scss">
.custom-authorized-dialog {
    .el-dialog__body {
        max-height: 760px;
        overflow-y: auto;
    }

    .custom-form-item-content {
        .el-form-item__content {
            height: auto;
            line-height: normal;
        }
    }

    .select-author-btn {
        width: 100%;
        height: 32px;
        padding: 12px;
        opacity: 1;
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #D9D9D9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(153, 153, 153, 1);
        cursor: pointer;

        .el-icon-arrow-down {
            color: #666666;
        }

        &:active {
            border-color: #409EFF;
        }
    }

    .label-tip-txt {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
    }
}

.author-list {
    .text-bold {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
        .handle_icon_wrap{
            margin-top: -3px;
            i{
                font-weight: 400;
            }
        }
    }

    .author-list-item {
        border-radius: 8px;
        background: #FFFFFF;
        border: 1px solid #E8E8E8;
        margin-bottom: 12px;

        .author-list-header {
            padding: 0 16px;
            height: 74px;
            align-items: center;
            justify-content: space-between;
            position: relative;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(153, 153, 153, 1);
        }

        .author-list-content {
            padding: 16px 16px 0;
            position: relative;
            &::before {
                content: "";
                position: absolute;
                left: 16px;
                right: 16px;
                top: 0;
                height: 1px;
                background: #E8E8E8;
            }
        }

        .content-tag-item {
            margin-bottom: 16px;

            &>div {
                margin-top: 12px;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(153, 153, 153, 1);

                .check-box {
                    width: 24px;
                    flex-shrink: 0;
                    padding-top: 2px;
                    box-sizing: border-box;
                }

                p:nth-child(1) {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                }
            }
        }
    }
}
</style>
